export const subnav = document.querySelector('.js-subnav');
const subnavLinks =
  document.querySelectorAll<HTMLLinkElement>('.js-subnav-link');
const subnavDropdownBtn = document.querySelector<HTMLButtonElement>(
  'button.js-subnav-dropdown-button',
);

if (subnav) {
  subnavLinks.forEach((link: HTMLLinkElement) => {
    const linkUrl = new URL(link.href);
    if (window.location.pathname === linkUrl.pathname) {
      link.classList.add('active');
      link.setAttribute('aria-current', 'page');
      setButtonText(link.innerText);
    }
  });

  if (window.location.href.includes('connect-with-a-minfraud-expert')) {
    setButtonText('Fraud prevention solutions');
  }

  if (window.location.href.includes('connect-with-a-geoip-expert')) {
    setButtonText('GeoIP solutions');
  }

  if (window.location.href.includes('contact-corrections')) {
    setButtonText('Correct other data');
  }
}

function setButtonText(text: string) {
  if (!subnavDropdownBtn) {
    return;
  }
  subnavDropdownBtn.innerText = text;
}
